import {Autocomplete, Text} from '../1elements'

const autocompleteSx = {
    padding: 0,
    maxWidth: '400px',
    '& .MuiInputBase-root': {
        padding: 0
    },
    '& .MuiAutocomplete-inputRoot': {
        maxHeight: '29px'
    },
    '& .MuiInputBase-input': {
        height: '10px'
    }
}

const ServiceNameSearch = ({options, onChangeAutocomplete, selectedService, setSearchKeyword}) => {
    const updateSearchField = (e) => {
        setSearchKeyword(e.target.value)
    }
    return (
        <div>
            <Text type={'fieldLabel'}>Service Name</Text>
            <Autocomplete sx={autocompleteSx} options={options} optionLabel={'serviceName'}
                          onChangeAutocomplete={onChangeAutocomplete} value={selectedService}
                          onChangeTextField={updateSearchField} />
        </div>
    )
}

export default ServiceNameSearch
